import { Component } from '@angular/core';


export class SkyTimepickerDemoComponent {
  public format12 = 'hh';
  public format24 = 'HH';
  public returnFormat = 'HH:mm:ssZ';
  public selectedTime1: any = '8:30 PM';
  public selectedTime2: any = '20:30';
  public selectedTime3: any = '02:00:00-0400';
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-timepicker-demo',
  template: `<h3>
  12-hour timepicker
</h3>

<div style="max-width: 400px">
  <sky-timepicker #timePickerExample1>
    <input
      type="text"
      [skyTimepickerInput]="timePickerExample1"
      [timeFormat]="format12"
      [(ngModel)]="selectedTime1"
      #time="ngModel">
  </sky-timepicker>

  <div
    class="sky-error-label"
    *ngIf="time.errors && time.errors.skyTime && (time.dirty || time.touched)">
    <span [hidden]="!time.errors.skyTime.invalid" >
      Please enter a valid time.
    </span>
  </div>
</div>

<div>
  Selected time is {{selectedTime1?.local}}
</div>

<br/>

<h3>
  24-hour timepicker.
</h3>

<div style="max-width: 400px">
  <sky-timepicker #timePickerExample2>
    <input
    type="text"
    [skyTimepickerInput]="timePickerExample2"
    [timeFormat]="format24"
    [(ngModel)]="selectedTime2"
    #time2="ngModel">
  </sky-timepicker>
  <div
    class="sky-error-label"
    *ngIf="time2.errors && time2.errors.skyTime && (time2.dirty || time2.touched)">
    <span [hidden]="!time2.errors.skyTime.invalid">
      Please enter a valid time.
    </span>
  </div>
</div>

<div>
  Selected time is {{selectedTime2?.hour}}:{{selectedTime2?.minute}}
</div>

<br/>

<h3>
  Custom timepicker
</h3>

<div style="max-width: 400px">
  <sky-timepicker #timePickerExample3>
    <input
      type="hidden"
      [skyTimepickerInput]="timePickerExample3"
      [timeFormat]="format24"
      [returnFormat]="returnFormat"
      [(ngModel)]="selectedTime3"
      #time3="ngModel">
  </sky-timepicker>
  <div
    class="sky-error-label"
    *ngIf="time3.errors && time3.errors.skyTime && (time3.dirty || time3.touched)">
    <span [hidden]="!time.errors.skyTime.invalid">
      Please enter a valid time.
    </span>
  </div>
  Selected time is {{selectedTime3?.local}}
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
